import {Component, EventEmitter, HostListener, OnInit, Output, SimpleChanges} from '@angular/core';
import {LabManagerService} from "../lab-manager.service";
import {LabCostItemModel} from "../../models/lab-manager/lab-cost-item";
import {NavBarComponent} from "../../nav-bar/nav-bar.component";
import {LabManagerSharedDataService} from "../lab-manager-shared-data.service";

@Component({
    selector: 'app-lab-cost-calculator',
    templateUrl: './lab-cost-calculator.component.html',
    styleUrls: ['./lab-cost-calculator.component.css'],
    standalone: false
})
export class LabCostCalculatorComponent implements OnInit {

  analysisCostItems: LabCostItemModel[] = [];
  containerHeight: string = '';
  @Output() labItemCostChange: EventEmitter<LabCostItemModel[]> = new EventEmitter<LabCostItemModel[]>();
  tableHeight: string = (window.innerHeight - 360) + 'px';
  totalCost: number = 0;
  totalCostWithVat: number = 0;
  vat: number = 0;

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.tableHeight = (window.innerHeight - 360) + 'px';
    if(window.innerHeight < 900) {
      this.containerHeight = window.innerHeight - 350 + 'px';
    } else {
      this.containerHeight = '';
    }
  }

  constructor(
      private labManagerSharedDataService: LabManagerSharedDataService
  ) {
    labManagerSharedDataService.labAnalysisCostItemsTriggerSubject.subscribe(res => {
      this.analysisCostItems = res;
      this.calculateCost(true);
    });
  }

  ngOnInit(): void {
    this.onResize();
  }

  calculateCost(retrievingData: boolean) {
    this.totalCost = 0;

    for(let item of this.analysisCostItems) {
      this.totalCost += (item.unitPrice * item.qty);
    }

    if(this.totalCost) {
      this.vat = this.totalCost * .15;
      this.totalCostWithVat = this.vat + this.totalCost;
    }
    if(!retrievingData) {
      this.labItemCostChange.emit(this.analysisCostItems);
    }
  }

}
